<template>
    <DirectQuestionsPage/>
</template>
<script>
import DirectQuestionsPage from "@common/directQuestions/DirectQuestionsPage";
export default {
    components: {
        DirectQuestionsPage
    },
}
</script>
